import { useRef } from 'react';
import { MapPin, Navigation, Plane, Ship, Train, TrendingUp } from 'lucide-react';
import { motion, useInView } from 'motion/react';

export function Location() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section id="location" className="py-20 md:py-32 bg-slate-950 text-white border-t border-slate-800" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/6 border border-white/10 text-slate-200 mb-5"
          >
            <MapPin className="h-4 w-4 text-secondary" />
            <span className="text-sm">Ubicación Estratégica</span>
          </motion.div>

          <motion.h2
            initial={{ opacity: 0, y: 18 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.1 }}
            className="text-4xl md:text-5xl text-white mb-5 tracking-tight"
          >
            Zona Libre de Colón, Panamá
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 18 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.2 }}
            className="text-lg text-slate-300 leading-relaxed"
          >
            Estamos ubicados en la <strong>Zona Libre de Colón, Panamá</strong>, con acceso directo a puertos, transporte terrestre y conexiones internacionales clave.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 18 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.25 }}
            className="mt-6 flex flex-col items-center gap-3"
          >
            <a
              href="https://maps.app.goo.gl/3CcpBgEdy2rnQPPp6"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-secondary text-white font-semibold shadow-sm hover:bg-secondary/90 transition-colors"
            >
              <MapPin className="h-4 w-4" />
              Ver en Google Maps
            </a>
            <p className="text-sm text-slate-400 italic max-w-xl">
              Ubicación de la oficina administrativa; el proyecto se desarrolla en el lote aledaño.
            </p>
          </motion.div>
        </div>

        <div className="mt-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.7 }}
          >
            <div className="rounded-[1.5rem] border border-white/10 bg-white/5 p-3 md:p-6 shadow-sm backdrop-blur-sm">
              <div className="aspect-square md:aspect-[21/9] rounded-2xl bg-slate-900 border border-white/10 flex items-center justify-center relative overflow-hidden">
                <iframe
                  title="Ubicación de Free Zone Logistics Park"
                  src="https://www.google.com/maps?q=9.3538466,-79.8895836&z=17&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen={false}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </motion.div>
        </div>

      </div>
    </section>
  );
}
